@if (currentTimezone$ | async; as currentTimezone) {
  @if (meetDates.length > 1) {
    {{ date | aliveDate: currentMeetService.meet?.timeFormat : 'ccc' : currentTimezone.activeTimezone }}
  }
  {{ date | aliveDate: currentMeetService.meet?.timeFormat : DateTime.TIME_SIMPLE : currentTimezone.activeTimezone }}
}
